/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";
import type { Threshold } from "./Threshold";
import {
  ThresholdFromJSON,
  ThresholdFromJSONTyped,
  ThresholdToJSON,
  ThresholdToJSONTyped,
} from "./Threshold";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface StableThresholdSavedState
 */
export interface StableThresholdSavedState {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  readonly simulation?: string | null;
  /**
   *
   */
  readonly created?: Date | null;
  /**
   * tags provided as a list of strings
   */
  tags?: Array<string>;
  /**
   *
   */
  expiry?: Date | null;
  /**
   *
   */
  thresholds: Array<Threshold>;
  /**
   *
   */
  file?: FileReadOnly;
  /**
   *
   */
  uuid?: string;
}

/**
 * Check if a given object implements the StableThresholdSavedState interface.
 */
export function instanceOfStableThresholdSavedState(
  value: object
): value is StableThresholdSavedState {
  if (!("thresholds" in value) || value["thresholds"] === undefined) return false;
  return true;
}

export function StableThresholdSavedStateFromJSON(json: any): StableThresholdSavedState {
  return StableThresholdSavedStateFromJSONTyped(json, false);
}

export function StableThresholdSavedStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): StableThresholdSavedState {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    name: json["name"] == null ? undefined : json["name"],
    simulation:
      json["simulation"] === undefined
        ? undefined
        : json["simulation"] === null
        ? null
        : json["simulation"],
    created:
      json["created"] === undefined
        ? undefined
        : json["created"] === null
        ? null
        : parseDateTime(json["created"]),
    tags: json["tags"] == null ? undefined : json["tags"],
    expiry:
      json["expiry"] === undefined
        ? undefined
        : json["expiry"] === null
        ? null
        : parseDateTime(json["expiry"]),
    thresholds: (json["thresholds"] as Array<any>).map(ThresholdFromJSON),
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    uuid: json["uuid"] == null ? undefined : json["uuid"],
  };
}

export function StableThresholdSavedStateToJSON(json: any): StableThresholdSavedState {
  return StableThresholdSavedStateToJSONTyped(json, false);
}

export function StableThresholdSavedStateToJSONTyped(
  value?: Omit<StableThresholdSavedState, "url" | "simulation" | "created"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    tags: value["tags"],
    expiry: value["expiry"] == null ? value["expiry"] : serializeDateTime(value["expiry"]),
    thresholds: (value["thresholds"] as Array<any>).map(ThresholdToJSON),
    file: FileReadOnlyToJSON(value["file"]),
    uuid: value["uuid"],
  };
}
